import { SVGAttributes } from 'react'
import { twMerge } from 'tailwind-merge'

export const GymIcon = ({ className, ...props }: SVGAttributes<SVGElement>) => (
  <svg
    data-cy="gym-icon"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 21 15"
    className={twMerge('h-6 w-6 stroke-current', className)}
    {...props}
  >
    <path d="M5.3.9v6.8m0 0v7m0-7h10.1m-12.2-5v10M1 4.7v6M15.4 1v6.8m0 0v7m2.2-12v10m2.2-8v6" strokeMiterlimit="10" />
  </svg>
)
